import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MapLocations from './MapLocations';
import MapZoom from './MapZoom';
import BusComponent from "../BusComponent";
import SubscriptionProducts from "../../enums/SubscriptionProducts";

class MapControls extends BusComponent {
    constructor (props, context) {
        super(props, context);
        this.state = {
            currentUser: undefined,
            displayMapLocations: false,
        }
    }

    componentDidMount() {
        this.bindGluBusEvents({
            USER_INFO_GET_SUCCESS: this.onUserInfo,
        });
        this.emit('USER_INFO_GET_REQUEST', { source: this });
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onUserInfo(userInfo, source) {
        if (source !== this) return;
        const hasInternalToolsEnabled = userInfo.hasFeatureToggle(SubscriptionProducts.ApplicationAccessConfigurationOptions.ENABLE_INTERNAL_TOOLS);

        this.setState({
            currentUser: userInfo,
            displayMapLocations: hasInternalToolsEnabled
        });
    }

    render() {
        const { mapInstance, className, alignLeft } = this.props;
        const { displayMapLocations } = this.state;

        return (
            <div className={classNames('map-controls', className)}>
                {displayMapLocations && (
                    <MapLocations
                        mapInstance={mapInstance}
                        alignLeft={alignLeft}
                    />
                )}
                <MapZoom
                    mapInstance={mapInstance}
                    alignLeft={alignLeft}
                />
            </div>
        )
    }
}

MapControls.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    className: PropTypes.string,
    alignLeft: PropTypes.bool,
};

MapControls.defaultProps = {
    className: undefined,
    alignLeft: false,
};

export default MapControls;
